import apiClient from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetch SPOC emails for a given entityLOBType and aaDepartmentFunction.
 * POST api/Onboarding/get-spoc-emails
 *
 * Payload:
 * {
 *   "entityLOBType": "auto",
 *   "aaDepartmentFunction": "marketing"
 * }
 *
 * Response:
 * {
 *   "success": true,
 *   "message": "SPOC emails fetched successfully.",
 *   "data": [
 *     "pradip.mourya@acrossassist.com"
 *   ]
 * }
 */
export const fetchSpocEmailsAction = async ({
  entityLOBType,
  aaDepartmentFunction,
} = {}) => {
  try {
    const payload = {
      entityLOBType: (entityLOBType || "").toLowerCase().trim(),
      aaDepartmentFunction: (aaDepartmentFunction || "").toLowerCase().trim(),
    };

    const response = await apiClient.post(ATP_API_URL.SPOC_EMAIL_LIST, payload);

    if (response?.status === 200 && response?.data) {
      const isSuccess =
        response.data.success === true || response.data.success === "true";
      const rawData = response.data.data;

      const emails = Array.isArray(rawData)
        ? rawData
            .map((item) => {
              if (typeof item === "string") return item.trim();
              if (item && typeof item === "object") {
                return (
                  item.email ||
                  item.emailAddress ||
                  item.spocEmail ||
                  ""
                ).trim();
              }
              return String(item || "").trim();
            })
            .filter((email) => email && email.length > 0)
        : [];

      return {
        success: isSuccess && emails.length > 0,
        message: response.data.message || "",
        emails,
      };
    }

    return {
      success: false,
      message: response?.data?.message || "Failed to fetch SPOC emails",
      emails: [],
    };
  } catch (error) {
    console.error("[fetchSpocEmailsAction] error:", error);
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch SPOC emails",
      emails: [],
    };
  }
};

export default fetchSpocEmailsAction;
